import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as currenciesD3 from '../locales/format/currencies.json'

export const currencies = currenciesD3.default

// shareholder types
export const shareholderTypes = {
  FOUNDER: <FormattedMessage id="enums.shareholderTypes.Founder" />,
  FAMILY: <FormattedMessage id="enums.shareholderTypes.Family" />,
  MANAGEMENT: <FormattedMessage id="enums.shareholderTypes.Management" />,
  BUSINESS_ANGEL: <FormattedMessage id="enums.shareholderTypes.Business_Angel" />,
  VENTURE_CAPITALIST: <FormattedMessage id="enums.shareholderTypes.Venture_Capitalist" />,
  CORPORATE_VENTURE_CAPITALIST: (
    <FormattedMessage id="enums.shareholderTypes.Corporate_Venture_Capitalist" />
  ),
  SIM_INVESTOR: <FormattedMessage id="enums.shareholderTypes.New_Investor" />,
  EMPLOYEE: <FormattedMessage id="enums.shareholderTypes.Employee" />,
  ESOP_POOL: <FormattedMessage id="enums.shareholderTypes.ESOP_Pool" />,
}

export const selectableShareholderTypes = Object.keys(shareholderTypes).filter(
  (t) => t !== 'SIM_INVESTOR' && t !== 'ESOP_POOL' && t !== 'EMPLOYEE',
)

// shareholder types plural
export const shareholderTypesPlural = {
  FOUNDER: <FormattedMessage id="enums.shareholderTypesPlural.Founder" />,
  FAMILY: <FormattedMessage id="enums.shareholderTypesPlural.Family" />,
  MANAGEMENT: <FormattedMessage id="enums.shareholderTypesPlural.Management" />,
  BUSINESS_ANGEL: <FormattedMessage id="enums.shareholderTypesPlural.Business_Angel" />,
  VENTURE_CAPITALIST: <FormattedMessage id="enums.shareholderTypesPlural.Venture_Capitalist" />,
  CORPORATE_VENTURE_CAPITALIST: (
    <FormattedMessage id="enums.shareholderTypesPlural.Corporate_Venture_Capitalist" />
  ),
  SIM_INVESTOR: <FormattedMessage id="enums.shareholderTypesPlural.New_Investor" />,
  EMPLOYEE: <FormattedMessage id="enums.shareholderTypesPlural.Employee" />,
  ESOP_POOL: <FormattedMessage id="enums.shareholderTypesPlural.ESOP_Pool" />,
}

// this is used to map investor.type to correct grouped type
export const stakeholderTypes = {
  FOUNDER: 'founder',
  FAMILY: 'business_angel',
  MANAGEMENT: 'management',
  BUSINESS_ANGEL: 'business_angel',
  VENTURE_CAPITALIST: 'investor',
  CORPORATE_VENTURE_CAPITALIST: 'investor',
  SIM_INVESTOR: 'new_investor',
  EMPLOYEE: 'employee',
  ESOP_POOL: 'esop',
}

export const participationTypes = {
  DEBT: <FormattedMessage id="enums.participationTypes.Debt_Capital" />,
  EXIT_MONEY: <FormattedMessage id="enums.participationTypes.Exit_Money" />,
  CONVERTIBLE_NOTE: <FormattedMessage id="enums.participationTypes.ConvertibleNote" />,
  SHARE: <FormattedMessage id="enums.participationTypes.Shares" />,
  GRANTED_SHARE: <FormattedMessage id="enums.participationTypes.GrantedShares" />,
  ESOP: <FormattedMessage id="enums.participationTypes.Esop_Pool" />,
}

// liquidation preference accumulation turnus
export const accumulationTypes = {
  YEARLY_30_360: <FormattedMessage id="enums.accumulationTypes.Yearly_30_360" />,
  YEARLY_US_360: <FormattedMessage id="enums.accumulationTypes.Yearly_US_360" />,
  YEARLY_ACC_360: <FormattedMessage id="enums.accumulationTypes.Yearly_acc_360" />,
  YEARLY_ACC_ACC: <FormattedMessage id="enums.accumulationTypes.Yearly_acc_acc" />,
  YEARLY_ACC_365: <FormattedMessage id="enums.accumulationTypes.Yearly_acc_365" />,
  DAILY: <FormattedMessage id="enums.accumulationTypes.Daily" />,
  YEARLY: <FormattedMessage id="enums.accumulationTypes.Yearly" />,
  // MONTHLY: <FormattedMessage id="enums.accumulationTypes.Monthly" />,
  // QUARTERLY: <FormattedMessage id="enums.accumulationTypes.Quarterly" />,
}
export const accumulationTypesShort = {
  YEARLY_30_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_30_360" />,
  YEARLY_US_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_US_360" />,
  YEARLY_ACC_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_360" />,
  YEARLY_ACC_ACC: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_acc" />,
  YEARLY_ACC_365: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_365" />,
  DAILY: <FormattedMessage id="enums.accumulationTypesShort.Daily" />,
  // MONTHLY: <FormattedMessage id="enums.accumulationTypesShort.Monthly" />,
  // QUARTERLY: <FormattedMessage id="enums.accumulationTypesShort.Quarterly" />,
}

// Disabled options taken out (For modelling, as they do not need to be kept for backwards compatibility)
export const accumulationTypesShortFiltered = {
  YEARLY_30_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_30_360" />,
  YEARLY_US_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_US_360" />,
  YEARLY_ACC_360: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_360" />,
  YEARLY_ACC_ACC: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_acc" />,
  YEARLY_ACC_365: <FormattedMessage id="enums.accumulationTypesShort.Yearly_acc_365" />,
  DAILY: <FormattedMessage id="enums.accumulationTypesShort.Daily" />,
}

// anti-dilution types
export const antiDilutionTypes = {
  BROAD_BASED: <FormattedMessage id="enums.antiDilutionTypes.BROAD_BASED" />,
  NARROW_BASED: <FormattedMessage id="enums.antiDilutionTypes.NARROW_BASED" />,
  FULL_RATCHET: <FormattedMessage id="enums.antiDilutionTypes.FULL_RATCHET" />,
}

export const antiDilutionTransferTypes = {
  TRANSFER_SHARES: <FormattedMessage id="enums.antiDilutionTransferTypes.TRANSFER_SHARES" />,
  CAPITAL_INCREASE: <FormattedMessage id="enums.antiDilutionTransferTypes.CAPITAL_INCREASE" />,
}

export const antiDilutionCompensation = {
  COMMON_SHARES: <FormattedMessage id="enums.antiDilutionCompensation.COMMON_SHARES" />,
  INITIAL_INVESTMENT_ROUND: (
    <FormattedMessage id="enums.antiDilutionCompensation.INITIAL_INVESTMENT_ROUND" />
  ),
  DOWN_ROUND: <FormattedMessage id="enums.antiDilutionCompensation.DOWN_ROUND" />,
}

// anti-dilution duration
export const antiDilutionDuration = {
  NEXT_ROUND: <FormattedMessage id="enums.antiDilutionDuration.NEXT_ROUND" />,
  NEXT_DOWN: <FormattedMessage id="enums.antiDilutionDuration.NEXT_DOWN" />,
  INDEFINITE: <FormattedMessage id="enums.antiDilutionDuration.INDEFINITE" />,
}

// Currently disabled (keep displayed for backwards compatibility)
export const antiDilutionDurationDisabled = ['INDEFINITE']

export const eventTypes = {
  EQUITY_INVESTMENT: <FormattedMessage id="enums.eventTypes.EQUITY_INVESTMENT" />,
  CN_INVESTMENT: <FormattedMessage id="enums.eventTypes.CN_INVESTMENT" />,
  CN_CONVERSION: <FormattedMessage id="enums.eventTypes.CN_CONVERSION" />,
  DEBT_INVESTMENT: <FormattedMessage id="enums.eventTypes.DEBT_INVESTMENT" />,
  BUY_OUT: <FormattedMessage id="enums.eventTypes.BUY_OUT" />,
  SIM_ANTI_DILUTION: <FormattedMessage id="enums.eventTypes.SIM_ANTI_DILUTION" />,
  SIM_AUTO_CN_CONVERSION: <FormattedMessage id="enums.eventTypes.SIM_AUTO_CN_CONVERSION" />,
  SIM_DIVIDENDS: <FormattedMessage id="enums.eventTypes.SIM_DIVIDENDS" />,
  ESOP_CREATION: <FormattedMessage id="enums.eventTypes.ESOP_CREATION" />,
  ESOP_GRANT: <FormattedMessage id="enums.eventTypes.ESOP_GRANT" />,
  MANUAL_SHARES: <FormattedMessage id="enums.eventTypes.MANUAL_SHARES" />,
}

export const operationTypes = {
  ADD: <FormattedMessage id="enums.operationTypes.ADD" />,
  SUB: <FormattedMessage id="enums.operationTypes.SUB" />,
  ADD_DIVIDENDS: <FormattedMessage id="enums.operationTypes.ADD_DIVIDENDS" />,
  TRANSFER_LP_RIGHTS: <FormattedMessage id="enums.operationTypes.TRANSFER_LP_RIGHTS" />,
  RECEIVE_LP_RIGHTS: <FormattedMessage id="enums.operationTypes.RECEIVE_LP_RIGHTS" />,
}

export const capTypes = {
  NONE: <FormattedMessage id="enums.capTypes.NONE" />,
  INVESTMENT_RETURN: <FormattedMessage id="enums.capTypes.INVESTMENT_RETURN" />,
  // EXIT_VALUATION: <FormattedMessage id="enums.capTypes.EXIT_VALUATION" />, (not supported yet)
}

export const simulationRoundTypes = {
  UP_ROUND: <FormattedMessage id="enums.simulationRoundTypes.UP_ROUND" />,
  FLAT_ROUND: <FormattedMessage id="enums.simulationRoundTypes.FLAT_ROUND" />,
  DOWN_ROUND: <FormattedMessage id="enums.simulationRoundTypes.DOWN_ROUND" />,
}

export const exitReturnTypesIDs = {
  MULTIPLE: 'enums.exitReturnTypes.MULTIPLE',
  PREFERENCE_AMOUNT: 'enums.exitReturnTypes.PREFERENCE_AMOUNT',
  CAP_POINT: 'enums.exitReturnTypes.CAP_POINT',
  CONVERSION_POINT: 'enums.exitReturnTypes.CONVERSION_POINT',
  DEFAULT: 'enums.exitReturnTypes.DEFAULT',
  STRIKE_POINT: 'enums.exitReturnTypes.STRIKE_POINT',
}

export const userStatus = {
  FREE: <FormattedMessage id="enums.userStatus.FREE" />,
  SUPPORT: <FormattedMessage id="enums.userStatus.SUPPORT" />,
  ADMIN: <FormattedMessage id="enums.userStatus.ADMIN" />,
}

export const expertTypes = {
  BEGINNER: <FormattedMessage id="enums.expertTypes.BEGINNER" />,
  EXPERT: <FormattedMessage id="enums.expertTypes.EXPERT" />,
}

export const roundingModes = {
  FLOOR: <FormattedMessage id="enums.roundingModes.FLOOR" />,
  CEILING: <FormattedMessage id="enums.roundingModes.CEILING" />,
  HALF_UP: <FormattedMessage id="enums.roundingModes.HALF_UP" />,
}

export const roundTypes = {
  CONVERTIBLE_ONLY: <FormattedMessage id="enums.roundTypes.CONVERTIBLE_ONLY" />,
  BUYOUT: <FormattedMessage id="enums.roundTypes.BUYOUT" />,
  FOUNDING: <FormattedMessage id="enums.roundTypes.FOUNDING" />,
  PRE_SEED: <FormattedMessage id="enums.roundTypes.PRE_SEED" />,
  SEED: <FormattedMessage id="enums.roundTypes.SEED" />,
  SERIES_A: <FormattedMessage id="enums.roundTypes.SERIES_A" />,
  SERIES_B: <FormattedMessage id="enums.roundTypes.SERIES_B" />,
  SERIES_C: <FormattedMessage id="enums.roundTypes.SERIES_C" />,
  SERIES_D: <FormattedMessage id="enums.roundTypes.SERIES_D" />,
  SERIES_E: <FormattedMessage id="enums.roundTypes.SERIES_E" />,
  CUSTOM: <FormattedMessage id="enums.roundTypes.CUSTOM" />,
}

export const selectableRoundTypes = {
  FOUNDING: <FormattedMessage id="enums.roundTypes.FOUNDING" />,
  CONVERTIBLE_ONLY: <FormattedMessage id="enums.roundTypes.CONVERTIBLE_ONLY" />,
  BUYOUT: <FormattedMessage id="enums.roundTypes.BUYOUT" />,
  CUSTOM: <FormattedMessage id="enums.roundTypes.CUSTOM" />,
}

export const valuationTypes = {
  PRE_MONEY_POOL: <FormattedMessage id="esop.pool.preMoney" />,
  POST_MONEY_POOL: <FormattedMessage id="esop.pool.postMoney" />,
}

export const dilutionTypes = {
  BY_PRICE_ADJUSTMENT: <FormattedMessage id="esop.pool.byPriceAdjustment" />,
  BY_BACKING: <FormattedMessage id="esop.pool.byBacking" />,
  BY_DILUTION_OF_ALL: <FormattedMessage id="esop.pool.byDilutionOfAll" />,
}

export const sectors = {
  AGRICULTURE: <FormattedMessage id="enums.sectors.AGRICULTURE" />,
  AUTOMOTIVE: <FormattedMessage id="enums.sectors.AUTOMOTIVE" />,
  FINANCE: <FormattedMessage id="enums.sectors.FINANCE" />,
  REAL_ESTATE: <FormattedMessage id="enums.sectors.REAL_ESTATE" />,
  CONSULTING: <FormattedMessage id="enums.sectors.CONSULTING" />,
  EDUCATION: <FormattedMessage id="enums.sectors.EDUCATION" />,
  LIFE_SCIENCE: <FormattedMessage id="enums.sectors.LIFE_SCIENCE" />,
  ENERGY: <FormattedMessage id="enums.sectors.ENERGY" />,
  FOOD: <FormattedMessage id="enums.sectors.FOOD" />,
  ENTERTAINMENT: <FormattedMessage id="enums.sectors.ENTERTAINMENT" />,
  HUMAN_RESOURCES: <FormattedMessage id="enums.sectors.HUMAN_RESOURCES" />,
  INDUSTRIAL_GOODS: <FormattedMessage id="enums.sectors.INDUSTRIAL_GOODS" />,
  INFORMATION_TECHNOLOGY: <FormattedMessage id="enums.sectors.INFORMATION_TECHNOLOGY" />,
  MEDIA: <FormattedMessage id="enums.sectors.MEDIA" />,
  HEALTH: <FormattedMessage id="enums.sectors.HEALTH" />,
  TEXTILE: <FormattedMessage id="enums.sectors.TEXTILE" />,
  TOURISM: <FormattedMessage id="enums.sectors.TOURISM" />,
  OTHER: <FormattedMessage id="enums.sectors.OTHER" />,
}

export const revisionTypes = {
  ADD: <FormattedMessage id="revisionType.ADD" />,
  MOD: <FormattedMessage id="revisionType.MOD" />,
  DEL: <FormattedMessage id="revisionType.DEL" />,
}

export const projectRoles = {
  LIMITED_VIEWER: <FormattedMessage id="accountRights.LIMITED_VIEWER" />,
  VIEWER: <FormattedMessage id="accountRights.VIEWER" />,
  ADMIN: <FormattedMessage id="accountRights.ADMIN" />,
  OWNER: <FormattedMessage id="accountRights.OWNER" />,
  SUPPORT: <FormattedMessage id="accountRights.SUPPORT" />,
}

export const exitRightTypes = {
  LP: <FormattedMessage id="exitRightTypes.LP" />,
  PAY_OUT: <FormattedMessage id="exitRightTypes.PAY_OUT" />,
  CN_PAY_BACK: <FormattedMessage id="exitRightTypes.CN_PAY_BACK" />,
  DEBT_PAY_BACK: <FormattedMessage id="exitRightTypes.DEBT_PAY_BACK" />,
  PRO_RATA_CAP: <FormattedMessage id="exitRightTypes.PRO_RATA_CAP" />,
  PRO_RATA: <FormattedMessage id="exitRightTypes.PRO_RATA" />,
  SECONDARY: <FormattedMessage id="exitRightTypes.SECONDARY" />,
  OTHER: <FormattedMessage id="exitRightTypes.OTHER" />,
}

export const exitRightTypesShort = {
  ...exitRightTypes,
  LP: <FormattedMessage id="exitRightTypesShort.LP" />,
}

export const organizationTypes = {
  STARTUP: <FormattedMessage id="organizationTypes.STARTUP" />,
  BUSINESS_ANGEL: <FormattedMessage id="organizationTypes.BUSINESS_ANGEL" />,
  SERVICE_PROVIDER: <FormattedMessage id="organizationTypes.SERVICE_PROVIDER" />,
  ENTERPRISE: <FormattedMessage id="organizationTypes.ENTERPRISE" />,
}

export const modellingProjectTypes = {
  SIMULATION: <FormattedMessage id="modellingProjectTypes.SIMULATION" />,
  CALCULATION: <FormattedMessage id="modellingProjectTypes.CALCULATION" />,
}

export const defaultPriceCalculationMethods = {
  AUTO_PRE_MONEY_FD: <FormattedMessage id="defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD" />,
  AUTO_PRE_MONEY_ND: <FormattedMessage id="defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND" />,
  AUTO_PRE_MONEY_INC_CNS_FD: (
    <FormattedMessage id="defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD" />
  ),
  AUTO_PRE_MONEY_INC_CNS_ND: (
    <FormattedMessage id="defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND" />
  ),
  AUTO_PRE_MONEY_AS_IF_FD: (
    <FormattedMessage id="defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD" />
  ),
  MANUAL_PRICE: <FormattedMessage id="defaultPriceCalculationMethods.MANUAL_PRICE" />,
}

// Defines the order that the shareholder groups are displayed e.g. in selection menus or tables
export const shareholderOrder = [
  'FOUNDER',
  'EMPLOYEE',
  'FAMILY',
  'MANAGEMENT',
  'BUSINESS_ANGEL',
  'VENTURE_CAPITALIST',
  'CORPORATE_VENTURE_CAPITALIST',
  'SIM_INVESTOR',
  'ESOP_POOL',
]

export const treeTypes = {
  RESULTS: 'RESULTS',
  SUPERNODES: 'SUPERNODES',
  SCENARIOS: 'SCENARIOS',
  FILTERED_SCENARIOS: 'FILTERED_SCENARIOS',
  CALCULATIONS: 'CALCULATIONS',
}

export const editTreeTypes = [treeTypes.SUPERNODES, treeTypes.CALCULATIONS]
export const resultTreeTypes = [
  treeTypes.RESULTS,
  treeTypes.SCENARIOS,
  treeTypes.FILTERED_SCENARIOS,
  treeTypes.CALCULATIONS,
]

export const restrictions = {
  NO_AUTH: 'NO_AUTH',
  NO_PREMIUM: 'NO_PREMIUM',
  NO_GROUP_OWNER: 'NO_GROUP_OWNER',
  NO_GROUP: 'NO_GROUP',
}

// https://www.ego4u.com/en/cram-up/vocabulary/numbers/ordinal
export const ordinalMap = {
  // exeptionals  (rest is th)
  1: 'st',
  2: 'nd',
  3: 'rd',
  5: 'th',
  8: 'th',
  9: 'th',
  12: 'th',
}

export function mimeTypeFromExtension(extension) {
  switch (extension) {
    case 'pdf':
      return 'application/pdf'
    case 'doc':
      return 'application/msword'
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    case 'ppt':
      return 'application/vnd.ms-powerpoint'
    case 'pptx':
      return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    case 'xls':
    case 'xlm':
      return 'application/vnd.ms-excel'
    case 'xlsm':
      return 'application/vnd.ms-excel.sheet.macroEnabled.12'
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    default:
      return ''
  }
}
